import globals from '../../../components/common/globals';

export default {
  name: 'vx-mystery-header',
  data() {
    return {
      globals,
    };
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-header/vx-mystery-header.js